module.exports = __webpack_public_path__ + "img/icon-RAZ.c31d944b.svg";